// LIBRERIE/IMPORTS
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import he from 'he';
//import appConfig from "../../config/appConfig";

// HOOKS
import { useGetAgentsByAgency } from "../../hooks/useGetAgents";
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";

// COMPONENTI
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";
import AgentsSection from "./AgentsSection";
import ServerError from "../Error/ServerError";
import LoadingIndicator from "../Loaders/LoadingIndicator";
//import WidgetContacts from "../Widgets/WidgetContacts/WidgetContacts";
//import WidgetPartners from "../Widgets/WidgetPartners/WidgetPartners";

interface AboutUsProps {
    agencyId: number;
    showAgents: boolean;
}

const AboutUs: React.FC<AboutUsProps> = ({ agencyId, showAgents }) => {
    const { t } = useTranslation();
    //const partners = appConfig.content.partners;
    const { agents, loading: agentsLoading, error: agentsError } = useGetAgentsByAgency(agencyId);
    const { agency, loading: agencyLoading, error: agencyError } = useGetAgencyDetails(agencyId);

    if (agencyLoading) return <LoadingIndicator />;
    if (agencyError) return <ServerError />;
    if (agentsLoading && showAgents) return <LoadingIndicator />;
    if (agentsError && showAgents) console.error("Error fetching agents:", agentsError);

    return (
        <>
            <Helmet>
                <title>{t('aboutUsPage.pageTitle')} | {he.decode(`${agency?.agencyName}`) || 'Agenzia Immobiliare'}</title>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
                <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;0,700;1,400&family=Lato:wght@300;400&display=swap" rel="stylesheet" />
            </Helmet>

            <SubHeaderDefault title={t('aboutUsPage.subHeaderTitle')} isSeo={true} />

            <main id="about-us-page" className="space-ptb bg-custom position-relative">
                <div className="container-fluid w-special">
                    <div className="mb-4">
                        <h2 className="mb-4">{t('aboutUsPage.title1')}</h2>
                        <p className="w-para" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para1') as string }} />
                    </div>
                    <div className="row align-items-center mb-4">
                        <div className="col-12 col-lg-6 col-xl-7">
                            <h3>{t('aboutUsPage.title2')}</h3>
                            <p className="w-para" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para2') as string }} />
                            <p className="w-para" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para3') as string }} />
                            <ul>
                                <li className="w-para" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.listItem1') as string }} />
                                <li className="w-para" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.listItem2') as string }} />
                                <li className="w-para" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.listItem3') as string }} />
                                <li className="w-para" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.listItem4') as string }} />
                            </ul>
                        </div>
                        <div className="col-12 col-lg-6 col-xl-5 text-center">
                            <img className="img-fluid" src="/assets/images/altrePag/sede.jpg" alt={t('aboutUsPage.altImg') as string} />
                        </div>
                    </div>
                    <div className="mb-4">
                        <h3>{t('aboutUsPage.title3')}</h3>
                        <p className="w-para" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para4') as string }} />
                        <p className="w-para" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para5') as string }} />
                    </div>
                    <AgentsSection
                        showAgents={showAgents}
                        agents={agents}
                        agentsLoading={agentsLoading}
                        agentsError={agentsError}
                    />
                </div>
            </main>
        </>
    );
};
export default AboutUs;